// 等待页面完全加载
document.addEventListener('DOMContentLoaded', function() {
    // 获取目录相关元素
    const tocHeader = document.getElementById('tocHeader');
    const tocContent = document.getElementById('tocContent');
    const tocToggle = document.getElementById('tocToggle');
    let isOpen = false;
    
    // 确保元素存在
    if (tocHeader && tocContent && tocToggle) {
        // 切换目录显示状态的函数
        function toggleToc() {
            isOpen = !isOpen;
            
            if (isOpen) {
                // 展开目录
                tocContent.classList.add('open');
                tocToggle.classList.add('open');
                tocToggle.textContent = '▲';
                // 触发动画效果
                setTimeout(() => {
                    tocContent.style.maxHeight = tocContent.scrollHeight + 'px';
                }, 10);
            } else {
                // 收起目录
                tocContent.style.maxHeight = '0';
                tocContent.classList.remove('open');
                tocToggle.classList.remove('open');
                tocToggle.textContent = '▼';
            }
        }
        
        // 为目录头部添加点击事件
        tocHeader.addEventListener('click', toggleToc);
        
        // 为切换按钮添加点击事件，防止事件冒泡
        tocToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleToc();
        });
    }

    // 目录链接平滑滚动功能
    const tocLinks = document.querySelectorAll('.eo-toc-mobile a, .eo-toc-desktop a');
    tocLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                // 计算滚动位置
                const headerOffset = 80;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                // 平滑滚动到目标位置
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                
                // 移动端点击后关闭目录
                if (window.innerWidth <= 1100 && isOpen) {
                    toggleToc();
                }
            }
        });
    });

    // 返回顶部按钮功能
    const backToTopButton = document.querySelector('.back-to-top');
    if (backToTopButton) {
        window.addEventListener('scroll', () => {
            // 滚动超过300px时显示按钮
            backToTopButton.classList.toggle('visible', window.pageYOffset > 300);
        });
        
        backToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    // 滚动时高亮当前目录项
    window.addEventListener('scroll', () => {
        const sections = document.querySelectorAll('.section-anchor');
        const navLinks = document.querySelectorAll('.eo-toc-desktop a, .eo-toc-mobile a');
        
        let currentSection = '';
        
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            if (pageYOffset >= (sectionTop - 150)) {
                currentSection = section.getAttribute('id');
            }
        });
        
        navLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${currentSection}`) {
                link.classList.add('active');
            }
        });
    });
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    // 初始化所有FAQ为关闭状态
    faqQuestions.forEach(question => {
        const answer = question.nextElementSibling;
        answer.classList.remove('active');
        answer.style.maxHeight = '0';
    });
    
    faqQuestions.forEach(question => {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;
            const isCurrentlyActive = this.classList.contains('active');
            
            // 关闭所有已展开的FAQ
            faqQuestions.forEach(q => {
                q.classList.remove('active');
                const ans = q.nextElementSibling;
                ans.classList.remove('active');
                ans.style.maxHeight = '0';
            });
            
            // 如果当前FAQ原本是关闭的，则展开它
            if (!isCurrentlyActive) {
                this.classList.add('active');
                answer.classList.add('active');
                // 动态计算所需高度（+50防止内容截断）
                answer.style.maxHeight = answer.scrollHeight + 50 + 'px';
            }
        });
    });
});

// Fragrance Oil Calculator Script
document.addEventListener("DOMContentLoaded", () => {
  const projectSelect = document.getElementById("fo-project-type");
  const batchSizeInput = document.getElementById("batch-size");
  const batchUnitSelect = document.getElementById("batch-unit");
  const loadInput = document.getElementById("fragrance-load");
  const loadHint = document.getElementById("fo-load-hint");
  const calcBtn = document.getElementById("fo-calc-btn");

  const resultMainText = document.getElementById("fo-result-main-text");
  const resultGrid = document.getElementById("fo-result-grid");
  const mainValueSpan = document.getElementById("fo-main-value");
  const mainUnitSpan = document.getElementById("fo-main-unit");
  const altValueSpan = document.getElementById("fo-alt-value");
  const altUnitSpan = document.getElementById("fo-alt-unit");

  // 快速百分比按钮
  document.querySelectorAll(".fo-quick-button").forEach((btn) => {
    btn.addEventListener("click", () => {
      const value = btn.getAttribute("data-value");
      if (loadInput) loadInput.value = value;
    });
  });

  // 根据项目类型更新提示 & 默认百分比
  function updateLoadHint() {
    if (!projectSelect || !loadHint) return;
    const val = projectSelect.value;

    if (val === "candle") {
      loadHint.textContent = "(candles: usually 6–10%)";
      if (!loadInput.value) loadInput.value = 8;
    } else if (val === "cp-soap") {
      loadHint.textContent = "(cold process soap: often 3–5%)";
      if (!loadInput.value) loadInput.value = 3;
    } else if (val === "mp-soap") {
      loadHint.textContent = "(melt and pour soap: usually 1–3%)";
      if (!loadInput.value) loadInput.value = 2;
    } else {
      loadHint.textContent = "(check supplier guidelines for this project)";
    }
  }

  if (projectSelect) {
    projectSelect.addEventListener("change", updateLoadHint);
    updateLoadHint();
  }

  // 计算函数
  function calculateFragrance() {
    if (!batchSizeInput || !loadInput || !batchUnitSelect) return;

    const batchSize = parseFloat(batchSizeInput.value);
    const load = parseFloat(loadInput.value);
    const unit = batchUnitSelect.value;

    if (isNaN(batchSize) || batchSize <= 0) {
      resultMainText.textContent = "Please enter a valid batch size greater than 0.";
      resultGrid.style.display = "none";
      return;
    }

    if (isNaN(load) || load <= 0) {
      resultMainText.textContent = "Please enter a valid fragrance load percentage.";
      resultGrid.style.display = "none";
      return;
    }

    if (load > 15) {
      resultMainText.textContent =
        "Fragrance load above 15% is not recommended. Please choose a lower percentage.";
      resultGrid.style.display = "none";
      return;
    }

    const amount = batchSize * (load / 100); // same unit as batch
    let altAmount, mainUnit, altUnit;

    if (unit === "g") {
      mainUnit = "g";
      altUnit = "oz";
      altAmount = amount / 28.3495;
    } else {
      mainUnit = "oz";
      altUnit = "g";
      altAmount = amount * 28.3495;
    }

    if (mainValueSpan && mainUnitSpan && altValueSpan && altUnitSpan) {
      mainValueSpan.textContent = amount.toFixed(2);
      mainUnitSpan.textContent = mainUnit;
      altValueSpan.textContent = altAmount.toFixed(2);
      altUnitSpan.textContent = altUnit;
    }

    resultMainText.textContent =
      "Here is your total fragrance oil amount based on batch size and percentage:";
    resultGrid.style.display = "flex";
  }

  if (calcBtn) {
    calcBtn.addEventListener("click", calculateFragrance);
  }

  // FAQ 展开 / 收起
  document.querySelectorAll(".fo-faq-item").forEach((item) => {
    const question = item.querySelector(".fo-faq-question");
    if (!question) return;
    question.addEventListener("click", () => {
      item.classList.toggle("fo-open");
    });
  });
});
